export class ItemsDto{
    itemId:number;
    item:string;
    consumptionrequired:boolean;
    consumption:number;
    createdUser:string;
    updatedUser:string;
    isActive:boolean;
    isOrderFormRequired?:boolean

    
    constructor(itemId:number,item:string,consumptionrequired:boolean, consumption:number,createdUser:string,updatedUser:string,isActive:boolean,    isOrderFormRequired?:boolean
    ){
        this.itemId = itemId;
        this.item = item;
        this.consumptionrequired=consumptionrequired;
        this.consumption=consumption;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;
        this.isActive = isActive;
        this.isOrderFormRequired = isOrderFormRequired
    }
}